<template>
  <div class="app-container">
    <div class="chuKuZuoyeWarp-body">
      <div ref="searchBox" class="formBox margbot">
          <el-form :inline="true"  class="demo-form-inline" label-width="80px" style="width: 100%;"
        size="mini">
        <div class="formItemBox">
            <el-form-item label="验收日期">
              <div style="display: flex;">
              <el-date-picker
                v-model="formData.acceptanceDateStart"
                size="mini"
                placeholder="请选择验收日期"
                type="date"
                value-format="yyyy-MM-dd"
                ></el-date-picker>
              -
              <el-date-picker
                v-model="formData.acceptanceDateEnd"
                size="mini"
                placeholder="请选择验收日期"
                type="date"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
              </div>
            </el-form-item>
            <el-form-item label="货主">
              <el-select
              v-model="formData.customerTaxId"
              size="mini"
              placeholder="请选择货主">
                <el-option
                  v-for="(item,index) in HZData"
                  :key="index"
                  :label="item.custerName"
                  :value="item.taxpayerNumber"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="仓库名称">
              <el-select
              v-model="formData.warehouseId"
              size="mini"
              placeholder="请选择仓库名称"
              @change="CKChange"
              >
                <el-option
                v-for="(item) in CHData"
                :label="item.warehouseName"
                :key="item.warehouseId"
                :value="item.warehouseId"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="产线名称">
              <el-select
              v-model="formData.productionEquipmentName"
              size="mini"
              placeholder="请选择产线名称">
                <el-option
                v-for="item in CXData"
                :label="item.equipmentName"
                :key="item.equipmentName"
                :value="item.equipmentName"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="主操">
              <el-input
              v-model="formData.mainOperator"
              size="mini"
              style="width:180px"
              placeholder="请输入主操"
              ></el-input>
            </el-form-item>
          </div>
            <el-form-item>
              <el-button type="primary" @click="chaxun">
                查询
              </el-button>
              <el-button type="primary" :disabled="isDisable" @click="daochu">
                导出
              </el-button>
              <el-button type="primary" @click="chongzhi">
                重置
              </el-button>
            </el-form-item>
          </el-form>
      </div>
      <div :style="{height:h}">
        <el-table
          size="mini"
          height="100%"
          ref="table"
          :data="tableData"
          style="width:100%"
          :row-style="{height:'20px'}"
          :cell-style="{padding:'0px'}"
          class="tableComent"
          :header-cell-style="{background:'#F5F5F5',color:'black'}"
        >
          <el-table-column
            label="验收日期"
            width="100px"
            prop="acceptanceDate"
          >
            <template slot-scope="scope">
              <span>{{scope.row.acceptanceDate == null?'合计':scope.row.acceptanceDate}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="加工前重量（吨）"
            width="150px"
            prop="processBeforeWeight"
          ></el-table-column>
          <el-table-column
            label="成品重量（吨）"
            width="150px"
            prop="productWeight"
          ></el-table-column>
          <el-table-column
            label="半成品重量（吨）"
            prop="semiProductWeight"
            width="150px"
          ></el-table-column>
          <el-table-column
            label="边丝重量（吨）"
            width="150px"
            prop="edgewiseWeight"
          ></el-table-column>
          <el-table-column
            label="单靠重量（吨）"
            width="150px"
            prop="aloneWeight"
          ></el-table-column>
          <el-table-column
            label="头尾重量（吨）"
            width="150px"
            prop="headTailWeight"
          ></el-table-column>
          <el-table-column
            label="余卷重量（吨）"
            width="150px"
            prop="remainingRollsWeight"
          ></el-table-column>
          <el-table-column
            label="余料重量（吨）"
            width="150px"
            prop="materialSurplusWeight"
          ></el-table-column>
          <el-table-column
            label="仓库名称"
            width="150px"
            prop="warehouseName"
          ></el-table-column>
          <el-table-column
            label="产线"
            width="200px"
            prop="productionEquipmentName"
          ></el-table-column>
          <el-table-column
            label="主操"
            width="100px"
            prop="mainOperator"
          ></el-table-column>
          <el-table-column
            label="货主"
            width="200px"
            prop="customerName"
          ></el-table-column>
        </el-table>
      </div>
      <!--分页-->
        <div class="pags" style="text-align: right;">
          <el-pagination
            background
            @current-change="handleCurrentChangeA"
            :current-page="current"
            :page-size="formData.pageSize"
            :page-sizes="[10, 20, 30, 40,50]"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChangeA"
            :total="total"
          ></el-pagination>
        </div>
    </div>
  </div>
</template>

<script>

import {
  getRelationCustomer,
  zidianKuwei,
  findEquipmentList,
  getProductionlineReport
} from '@/api/wms-stock'
import DonMessage from '@/utils/message'
import { exportExcel } from '@/utils/fileDown.js'
import { dateFormat1 } from '@/utils/util'

export default {
  data () {
    return {
      formData: {
        customerTaxId: '',
        acceptanceDateStart: '',
        acceptanceDateEnd: '',
        warehouseId: '',
        productionEquipmentName: '',
        mainOperator: '',
        pageSize: 20,
        pageNo: 1
      },
      HZData: [],
      CHData: [],
      CXData: [],
      tableData: [],
      h: '',
      current: 1,
      total: 0,
      isDisable: false
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight

    this.h = (pH - 46 - 115 - h) + 'px'

    this.formData.acceptanceDateStart = dateFormat1(new Date() - 30 * 24 * 60 * 60 * 1000, '-')
    this.formData.acceptanceDateEnd = dateFormat1(new Date() - 24 * 60 * 60 * 1000, '-')

    this.getRelationCustomerS()
    this.zidianKuweiS()
    this.getProductionlineReportS()
  },
  methods: {
    handleCurrentChangeA (val) {
      this.current = val
      this.formData.pageNo = val
      this.getProductionlineReportS()
    },
    handleSizeChangeA (val) {
      this.formData.pageSize = val
      this.getProductionlineReportS()
    },
    CKChange (option) {
      this.findEquipmentListS(option)
    },
    getProductionlineReportS () {
      getProductionlineReport(this.formData)
        .then(res => {
          res.pageInfo.list.forEach(item => {
            item.acceptanceDate = new Date(item.acceptanceDate).toLocaleDateString().replace(/\//g, '-')
          })
          res.pageInfo.list.unshift(res.allWeight)

          this.tableData = res.pageInfo.list
          this.total = res.pageInfo.total
          console.log(res)
        })
        .catch(err => {
          DonMessage.error(err.message)
        })
    },
    chaxun () {
      console.log(this.formData)
      this.getProductionlineReportS()
    },
    // 点击导出
    daochu () {
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 5000)
      let form = this.formData
      // delete form.pageNo
      // delete form.pageSize

      exportExcel(
        this.global.wmsStockName +
          '/tProductionlineReport/exportProductionlineReportList',
        form,
        '加工产线报表'
      )
    },
    chongzhi () {
      this.formData.customerTaxId = ''
      this.formData.acceptanceDateStart = ''
      this.formData.acceptanceDateEnd = ''
      this.formData.warehouseId = ''
      this.formData.productionEquipmentName = ''
      this.formData.mainOperator = ''
      this.getProductionlineReportS()
    },
    // 字典-查询客户
    getRelationCustomerS () {
      getRelationCustomer({})
        .then((res) => {
          this.HZData = res
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },

    // 字典--库位
    zidianKuweiS () {
      zidianKuwei({})
        .then((res) => {
          this.CHData = res
        })
        .catch((err) => {
          console.log(err)
        })
    },
    findEquipmentListS (warehouseId) {
      findEquipmentList({
        equipmentType: 2,
        warehouseId
      })
        .then((res) => {
          this.CXData = res
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }

}
</script>

<style lang="less" scoped>
.chuKuZuoyeWarp {
  width: 100%;
  position: relative;
  height: 100%;
}
.demo-form-inline{
  margin-left: 10px ;
}
.chuKuZuoyeWarp-body-queryIpt {
      width: 100%;
      display: flex;
      font-size: 14px;
}
  .formBox /deep/ .el-form-item{
  margin-bottom: 6px!important;
}

</style>
